import Degree from "./degree";
export default Degree;